import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

function searchAttendees() {
	const $attendees = jQuery('.events-attendees--attendee');
	const $searchInput = jQuery('.attendees-search-form input[name="search"]');
	const $noResultsMessage = jQuery('.no-results-message');

	const searchVal = $searchInput.val().toLowerCase();
	const selectedFilter = jQuery('#dd-attendees li.active').data('key');
	const showAll = !selectedFilter || selectedFilter === 'all';
	let visibleCount = 0;

	$attendees.each(function () {
		const $this = jQuery(this);
		const name = $this.find('.events-attendees--name').text().toLowerCase();
		const organization = $this.find('.events-attendees--org').text().toLowerCase(); // updated selector
		const industries = ($this.data('industries') || '').split(' ');

		const matchesSearch = name.includes(searchVal) || organization.includes(searchVal);
		const matchesFilter = showAll || industries.includes(selectedFilter);

		if (matchesSearch && matchesFilter) {
			$this.show();
			visibleCount++;
		} else {
			$this.hide();
		}
	});

	if (visibleCount === 0) {
		$noResultsMessage.show();
	} else {
		$noResultsMessage.hide();
	}
}



export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
	},
	finalize() {
		jQuery('.event-day-1').show()
		jQuery('.event-day-2').hide()

		jQuery('#overview .tf-dropdown ul li').on('click', function () {
			let thisvalue = parseInt(jQuery(this).data('key')) + 1

			jQuery('.event-card').hide()
			jQuery('.event-day-' + thisvalue).fadeIn(250)

			if (thisvalue == 2) {
				jQuery('.events-schedule').hide()
				jQuery('.events-presenters').hide()
			} else {
				jQuery('.events-schedule').show()
				jQuery('.events-presenters').show()
			}
		})

		function handleNavigationLine() {
			let line = jQuery('.events-navigation-line')
			let nav_items = jQuery('.events-navigation ul li a')
			let current_nav_item = handleGetCurrentElement()

			if (current_nav_item != 'overview') {
				let li_item = $(
					'.events-navigation ul li[data-el="' + current_nav_item + '"]'
				)
				current_nav_item = li_item.index()
			} else {
				current_nav_item = 0
			}

			if (line && line.length) {
				if (nav_items.length && nav_items[current_nav_item]) {
					setTimeout(function () {
						let nav_item_width = jQuery(
							nav_items[current_nav_item]
						).outerWidth()
						let nav_item_left = jQuery(nav_items[current_nav_item]).position()
							.left
						line
							.css('width', nav_item_width + 5 + 'px')
							.css('left', nav_item_left + 'px')
							.show()
					}, 100)
				}
			}
		}

		function handleShowElement(element_id = false) {
			let sections = jQuery('.events-section')
			if (sections.length) {
				sections.hide()
			}

			if (element_id && document.getElementById(element_id)) {
				if (jQuery('#' + element_id).length) {
					jQuery('#' + element_id).show()
				}
			} else {
				let nav_items = jQuery('.events-navigation ul li')
				if (nav_items.length) {
					let show_element = jQuery(nav_items[0]).data('el')
					if (jQuery('#' + show_element)) {
						jQuery('#' + show_element).show()
					}
				}
			}
		}

		function handleNavigationEventListeners() {
			let nav_items = jQuery('.events-navigation ul li')
			if (nav_items.length) {
				nav_items.on('click', function (e) {
					e.preventDefault()

					let this_left_position = jQuery(e.target).position().left
					let this_width = jQuery(e.target).outerWidth() + 5
					let line = jQuery('.events-navigation-line')

					if (line) {
						line
							.css('left', this_left_position + 'px')
							.css('width', this_width + 'px')
					}

					let sections = jQuery('.events-section')
					let section_show = jQuery(e.target).parent().data('el')

					location.hash = 'section-' + section_show
				})
			}
		}

		function onHashChange() {
			let hash = location.hash
			hash = hash.replace('#', '').replace('section-', '')
			handleNavigationLine()
			if (jQuery('#' + hash).length) {
				let sections = jQuery('.events-section')
				sections.hide()
				jQuery('#' + hash).fadeIn(100)
			}
		}

		function handleHashChange() {
			window.addEventListener('hashchange', onHashChange)
		}

		function handleGetCurrentElement() {
			let current_hash = document.location.hash
				.replace('#', '')
				.replace('section-', '')
			if (current_hash.trim() != '') {
				return current_hash.trim()
			}
			return 'overview'
		}

		function handleFilter() {
			const filter = jQuery('#dd-attendees li')
		
			if (filter.length) {
				filter.on('click', function () {
					$('html, body').animate(
						{
							scrollTop:
								jQuery('#attendees').offset().top -
								jQuery('.navbar-wrap').outerHeight() -
								60,
						},
						200
					)
		
					// Update active class
					jQuery('#dd-attendees li').removeClass('active')
					jQuery(this).addClass('active')
		
					// Re-run unified search + filter
					searchAttendees()
				})
			}
		}
		

		handleNavigationLine()
		handleShowElement(handleGetCurrentElement())
		handleNavigationEventListeners()
		handleHashChange()
		handleFilter()

		eventStats()
	},
}

function eventStats() {
	if ($('.event-hero-stats').length) {
		let heroTL = gsap.timeline({
			defaults: {
				duration: 0.35,
				opacity: 0,
				stagger: 0.3,
				ease: 'power2.out',
			},
			onComplete() {
				if ($('.stat-heading span').length) {
					// ScrollTrigger.create({
					// 	trigger: $('.event-hero-stats'),
					// 	start: 'center bottom',
					// 	onEnter: () => {
					// 		$('.stat-heading span').each(function () {
					// 			let $this = $(this),
					// 				countTo = $this.attr('data-count');
					// 			$({ countNum: $this.text() }).animate(
					// 				{
					// 					countNum: countTo,
					// 				},
					// 				{
					// 					duration: 1000,
					// 					easing: 'linear',
					// 					step() {
					// 						$this.text(Math.floor(this.countNum));
					// 					},
					// 					complete() {
					// 						$this.text(this.countNum);
					// 					},
					// 				}
					// 			);
					// 		});
					// 	},
					// });
				}
			},
		})
	}

	if ($('.hero-stats').length) {
		gsap
			.timeline({
				defaults: {
					duration: 0.3,
					opacity: 0,
					stagger: 0.3,
					ease: 'power2.out',
				},
			})
			.from('.event-hero-stats', {}, '-=0.25')
			.from('.event-hero-stat', { y: 8, stagger: 0.05 })
	}
}

(function ($) {
	$(document).ready(function () {
		const $attendees = $('.events-attendees--attendee');
		const $searchInput = $('.attendees-search-form input[name="search"]');
		const $noResultsMessage = $('.no-results-message');


		$('#dd-attendees li').on('click', function () {
			$('#dd-attendees li').removeClass('active');
			$(this).addClass('active');
			searchAttendees(); // filter + search together
		});

		$('.attendees-search-form').on('submit', function (e) {
			e.preventDefault();
		});

		$searchInput.on('input', searchAttendees);
	});
})(jQuery);
